(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nursem-buy-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const details = document.querySelector('.nursem-product-details');
    if (!details) return;

    // ── Variant option buttons ──
    const optionGroups = details.querySelectorAll('.nursem-variant-options');
    const variantInput = details.querySelector('[ref="variantId"]');

    // Find product variants JSON from script tag or inline
    let productData = [];
    const variantScript = details.querySelector('script[data-nursem-variants]');
    if (variantScript) {
      try { productData = JSON.parse(variantScript.textContent); } catch(e) {}
    }

    optionGroups.forEach(function(group) {
      group.addEventListener('change', function(e) {
        const radio = e.target;
        if (!radio.matches('input[type="radio"]')) return;

        group.querySelectorAll('label').forEach(function(label) {
          label.classList.remove('ns-bg-nursem-slate', 'ns-text-white');
          label.classList.add('ns-border', 'ns-border-solid', 'ns-border-nursem-slate', 'ns-text-nursem-slate');
        });
        radio.closest('label').classList.add('ns-bg-nursem-slate', 'ns-text-white');
        radio.closest('label').classList.remove('ns-border', 'ns-border-solid', 'ns-border-nursem-slate', 'ns-text-nursem-slate');

        var selectedOptions = [];
        details.querySelectorAll('.nursem-variant-options input[type="radio"]:checked').forEach(function(input) {
          selectedOptions.push(input.value);
        });

        var matchedVariant = productData.find(function(v) {
          return selectedOptions.every(function(opt, i) {
            return v.options[i] === opt;
          });
        });

        if (matchedVariant && variantInput) {
          variantInput.value = matchedVariant.id;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    // ── ReCharge toggle ──
    var rechargeInputs = details.querySelectorAll('[data-nursem-selling-plan]');
    var sellingPlanHidden = details.querySelector('[data-nursem-selling-plan-input]');

    rechargeInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var planId = input.getAttribute('data-selling-plan-id');
        if (sellingPlanHidden) {
          sellingPlanHidden.value = planId || '';
        }

        details.querySelectorAll('.nursem-recharge__option').forEach(function(opt) {
          opt.classList.remove('nursem-recharge__option--active', 'ns-bg-nursem-slate', 'ns-text-white');
          opt.classList.add('ns-border', 'ns-border-solid', 'ns-border-nursem-slate/50', 'ns-text-nursem-slate');
          opt.querySelector('.nursem-recharge__dot').classList.add('ns-hidden');
          opt.querySelector('.nursem-recharge__radio').classList.remove('ns-border-white');
          opt.querySelector('.nursem-recharge__radio').classList.add('ns-border-nursem-slate');
        });

        var label = input.closest('.nursem-recharge__option');
        label.classList.add('nursem-recharge__option--active', 'ns-bg-nursem-slate', 'ns-text-white');
        label.classList.remove('ns-border', 'ns-border-solid', 'ns-border-nursem-slate/50', 'ns-text-nursem-slate');
        label.querySelector('.nursem-recharge__dot').classList.remove('ns-hidden');
        label.querySelector('.nursem-recharge__radio').classList.add('ns-border-white');
        label.querySelector('.nursem-recharge__radio').classList.remove('ns-border-nursem-slate');
      });
    });

    // ── ReCharge OFFICIAL subscription widget → sync selected plan into our form ──
    // The merchant uses ReCharge's official app block (<recharge-subscription-widget>),
    // which sits in a SEPARATE block outside our form and keeps its selection in its
    // (open) shadow DOM as input[name="selling_plan"] radios. That plan id never reached
    // our form's hidden selling_plan input, so every add-to-cart was a one-off. Read the
    // widget's checked plan (piercing shadow roots) and mirror it into our input — on
    // change, and authoritatively at submit (capture phase) before Horizon builds FormData.
    var nursemForm = sellingPlanHidden ? sellingPlanHidden.closest('form') : null;
    var nursemLastPlan = null;

    // Search a node's (open) shadow root and descendants, piercing nested shadow roots.
    function nursemDeepQuery(node, selector) {
      var roots = [];
      if (node.shadowRoot) roots.push(node.shadowRoot);
      roots.push(node);
      for (var r = 0; r < roots.length; r++) {
        var root = roots[r];
        if (!root.querySelector) continue;
        var hit = root.querySelector(selector);
        if (hit) return hit;
        var nodes = root.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].shadowRoot) {
            var deep = nursemDeepQuery(nodes[i], selector);
            if (deep) return deep;
          }
        }
      }
      return null;
    }

    // ReCharge widget markup (confirmed on the live store): a purchaseOption radio
    // group (values "subscription" | "onetime", subscription checked by default) and a
    // <select name="rc_plan"> whose option values ARE the Shopify selling_plan ids. So
    // one-time → empty selling_plan; subscription → the chosen rc_plan value.
    function nursemSyncSellingPlan() {
      if (!sellingPlanHidden) return;
      var widget = document.querySelector('recharge-subscription-widget');
      if (!widget) return;
      var oneTime = nursemDeepQuery(widget, 'input[name="purchaseOption"][value="onetime"]');
      var subscription = nursemDeepQuery(widget, 'input[name="purchaseOption"][value="subscription"]');
      var planSelect = nursemDeepQuery(widget, 'input[name="rc_plan"]:checked') ||
      nursemDeepQuery(widget, 'select[name="rc_plan"]');
      var isOneTime = oneTime ? oneTime.checked === true : false;
      var isSubscription = subscription ? subscription.checked === true : !isOneTime;
      var next = (isSubscription && planSelect && planSelect.value) ? planSelect.value : '';
      sellingPlanHidden.value = next;
      // Broadcast the selection so other UI follows it — the mobile sticky bar uses
      // this to show the price of the chosen option (one-time vs subscription).
      if (next !== nursemLastPlan) {
        nursemLastPlan = next;
        document.dispatchEvent(new CustomEvent('nursem:selling-plan-change', {
          detail: { sellingPlanId: next }
        }));
      }
    }

    if (sellingPlanHidden) {
      // Live-sync whenever the widget's option changes. The radios live in the widget's
      // shadow DOM and their native `change` event is NOT composed, so it never reaches
      // the document (confirmed on the live store: only `click` and `input` escape the
      // shadow root, retargeted to the widget host). Listen for the composed events at
      // document level and re-read the widget state on the next tick, after the widget
      // has toggled the radio / re-rendered.
      function nursemOnWidgetInteraction(e) {
        var t = e.target;
        if (t && t.closest && t.closest('recharge-subscription-widget, .recharge-app-container, [id*="recharge_subscriptions"]')) {
          setTimeout(nursemSyncSellingPlan, 0);
          setTimeout(nursemSyncSellingPlan, 120);
        }
      }
      document.addEventListener('change', nursemOnWidgetInteraction, true);
      document.addEventListener('input', nursemOnWidgetInteraction, true);
      document.addEventListener('click', nursemOnWidgetInteraction, true);
      if (nursemForm) {
        // Backstops that guarantee the plan is set before the add fires — including the
        // default state (the widget defaults to subscription and fires no change event):
        // pointerdown/click on the ATC button run before the form submit, and the
        // capture-phase submit listener runs before Horizon's handler builds FormData.
        var nursemAtcBtn = nursemForm.querySelector('button[type="submit"]');
        if (nursemAtcBtn) {
          nursemAtcBtn.addEventListener('pointerdown', nursemSyncSellingPlan);
          nursemAtcBtn.addEventListener('click', nursemSyncSellingPlan);
        }
        nursemForm.addEventListener('submit', nursemSyncSellingPlan, true);
      }

      // Reflect the widget's DEFAULT state on load (it pre-selects subscription and
      // fires no change event), so the sticky bar shows the right price before any
      // interaction. The widget hydrates asynchronously, so poll briefly for it.
      (function nursemInitialPlanSync() {
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          var w = document.querySelector('recharge-subscription-widget');
          var ready = w && nursemDeepQuery(w, 'input[name="purchaseOption"]');
          if (ready || tries >= 24) {
            clearInterval(timer);
            // Also listen INSIDE the (open) shadow root so the non-composed `change`
            // event is caught directly, e.g. keyboard-driven radio changes.
            if (ready && w.shadowRoot) {
              w.shadowRoot.addEventListener('change', function () {
                setTimeout(nursemSyncSellingPlan, 0);
              });
            }
            nursemSyncSellingPlan();
          }
        }, 250);
      })();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
